export const Routing = {
  // common
  Initial: "/",
  Company: "/company",
  About:"/about",
  Products:"/product",
  PremiumFreezeDried:"/premium-freeze-dried",
  Profile:"/profile",
  OrderDetail:"/order/:id",
  OrderList:"/orders",
  OrderSuccess:"/order-success",
  Product_details:"/product/:name",
  Blog:"/blog",
  BlogDetails:"/blog/:name",
  Cart:"/cart",
  Checkout:"/checkout",
  Wishlist:"/wishlist",
  Gallery:"/gallery",
  Contact:'/contact',
  Review:'/review',
  ReviewDetails:'/review/:id',
  Upcoming_product_detals:'/product/:name',
  PrivacyPolicy:'/privacy-policy',
  ReturnsRefunds:'/returns-refunds',
  TermsConditions:'/terms-conditions',
  FAQs:'/faqs',
  ShoppingFAQs:'/shopping-faqs',
  AffiliateJoin:'/affiliate-join',
};
